import {
  CHANGE_SORTING,
  FETCH_VESSELS_SUCCESS,
  FETCH_PRODUCTS,
  FETCH_PRODUCTS_SERVICE_VESSELS,
  FETCH_PRODUCTS_SERVICE_VESSELS_SUCCESS,
  FETCH_SERVICE_VESSELS,
  FETCH_SERVICE_VESSELS_SUCCESS, FETCH_SHIPYARD_VESSELS, FETCH_SHIPYARD_VESSELS_SUCCESS,
  GET_CHART_DATA_SUCCESS,
  GET_PRODUCTS_CHART_DATA_SUCCESS,
  GET_PRODUCTS_SUCCESS,
  GET_SHIPYARD_CHART_DATA_SUCCESS
} from "../action/company-vessel-chart.action";
import { FETCH_AREAS_SUCCESS, FETCH_DEFICIENCY_CODES_SUCCESS } from "../action/filter.action";

const initialState = {
  statistics: [],
  referencedVessel: {},
  searchName: "",
  statisticsProducts: [],
  referencedVesselProducts: {},
  products: {},
  statisticsShipyards: [],
  referencedVesselShipyard: {},
  inspections: {},
  sortBy: [],
  areas: {},
  deficienciesCodes: [],
};

export default function companyVesselChartReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DEFICIENCY_CODES_SUCCESS:
      Object.assign(state.deficienciesCodes, action.payload)
      return {
        ...state,
        deficienciesCodes: action.payload,
        requestSerialDataTable: (state.requestSerialDataTable + 1),
      };
    case GET_CHART_DATA_SUCCESS:
      return {
        ...state,
        statistics: action.payload
      };

    case FETCH_SERVICE_VESSELS_SUCCESS:
      Object.assign(state.referencedVessel, action.payload)
      return {
        ...state,
        referencedVessel: action.payload,
        requestSerialDataTable: (state.requestSerialDataTable + 1),
      }

    case FETCH_SERVICE_VESSELS:
      let searchName = "";
      switch (action.searchName) {
        case "more than 30 days ago":
          searchName = "update30days";
          break;
        case "Last 7 days":
          searchName = "update7days";
          break;
        case "7 days - 30 days ago":
          searchName = "update7-30days";
          break;
        case "In shipyard":
          searchName = "inShipyardToday";
          break;
        case "expire within 1-3 months": case "expire 3-6 months": case "expire 6-12 months": case "expire more than 12 months": case "expire within 1 month": case "Not in Shipyard":
          searchName = action.searchName.replaceAll(" ", "_")
          break;
        default:
          searchName = action.searchName
          break;
      }
      return {
        ...state,
        searchName: searchName,
      }
    case FETCH_VESSELS_SUCCESS:
      Object.assign(state.inspections, action.payload)
      return {
        ...state,
        inspections: action.payload,
        requestSerialDataTable: (state.requestSerialDataTable + 1),
      };

    case FETCH_AREAS_SUCCESS:
      Object.assign(state.areas, action.payload)
      return {
        ...state,
        areas: action.payload,
        requestSerialDataTable: (state.requestSerialDataTable + 1),
      };

    case GET_PRODUCTS_CHART_DATA_SUCCESS:
      return {
        ...state,
        statisticsProducts: action.payload
      };

    case FETCH_PRODUCTS_SERVICE_VESSELS_SUCCESS:
      Object.assign(state.referencedVesselProducts, action.payload)
      return {
        ...state,
        referencedVesselProducts: action.payload,
        requestSerialDataTable: (state.requestSerialDataTable + 1),
      }

    case FETCH_PRODUCTS_SERVICE_VESSELS:
      searchName = "";
      switch (action.searchName) {
        case "more than 30 days ago":
          searchName = "update30days";
          break;
        case "Never Seen":
          searchName = "neverSeen";
          break;
        case "Last 7 days":
          searchName = "update7days";
          break;
        case "7 days - 30 days ago":
          searchName = "update7-30days";
          break;
        case "In shipyard":
          searchName = "inShipyardToday";
          break;
        case "expire within 1-3 months": case "expire 3-6 months": case "expire 6-12 months": case "expire more than 12 months": case "expire within 1 month": case "Not in Shipyard":
          searchName = action.searchName.replaceAll(" ", "_")
          break;
        default:
          searchName = action.searchName
          break;
      }
      return {
        ...state,
        searchName: searchName,
      }

    case GET_PRODUCTS_SUCCESS:
      Object.assign(state.products, action.payload)
      return {
        ...state,
        products: action.payload,
      }
    case FETCH_PRODUCTS:
      return {
        ...state,
        searchName: action.searchName,
      }

    case GET_SHIPYARD_CHART_DATA_SUCCESS:
      return {
        ...state,
        statisticsShipyards: action.payload
      };

    case FETCH_SHIPYARD_VESSELS_SUCCESS:
      Object.assign(state.referencedVesselShipyard, action.payload)
      return {
        ...state,
        referencedVesselShipyard: action.payload,
        requestSerialDataTable: (state.requestSerialDataTable + 1),
      }

    case FETCH_SHIPYARD_VESSELS:
      searchName = "";
      switch (action.searchName) {
        case "less than 6 Months":
          searchName = "lessThan6Months";
          break;
        case "in 6-12 Months":
          searchName = "in6-12Months";
          break;
        case "more than 12 Months":
          searchName = "moreThan12Months";
          break;
        default:
          searchName = action.searchName
          break;
      }
      return {
        ...state,
        searchName: searchName,
      }
    case CHANGE_SORTING:
      return {
        ...state,
        sortBy: action.sortBy,
      }
    default:
      return state;
  }
}